import React from 'react';
import MultiChoiceFilter from '../MultiChoiceFilter';
export function FilterRenderer(_ref) {
  let {
    column,
    filters,
    onFilterChange
  } = _ref;
  const {
    key: columnKey
  } = column;
  const filterValue = filters[columnKey] || '';
  if (!column.filterableByText) return null;
  return /*#__PURE__*/React.createElement(MultiChoiceFilter, {
    dataTestId: `datagrid-filter-${columnKey}`,
    value: filterValue,
    onChange: nextValue => onFilterChange(columnKey, nextValue),
    placeholder: "Filter...",
    showPlusButton: false,
    type: "text",
    inputSize: "sm",
    inputStyle: {
      width: '100%',
      padding: '4px',
      fontSize: '12px',
      border: '1px solid #ddd',
      borderRadius: '3px',
      boxSizing: 'border-box'
    },
    style: {
      width: '100%',
      boxSizing: 'border-box'
    }
  });
}